(function () {
  'use strict';

  function TiposEventos() {
    return {
      templateUrl: `configuracoes/eventos/subpaginas/tipos/tipos-eventos.tpl.html`,
      controller: 'TiposEventosCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular
    .module('SubpaginasEventos')
    .directive('tiposEventos', TiposEventos);
}());
